<template>
<v-flex xs12>
  <v-layout align-center justify-center row fill-height>
  <material-card style="border: 5px dashed #000; border-radius: 4px 10px 10px 10px; background-color: transparent; box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);"
    v-bind="$attrs"
    class="v-card--material-stats pa-0 ma-0"
    v-on="$listeners"
    max-width="200"
    max-height="200"
    min-width="200"
    min-height="200"
    color="none"
  >
    <div class="text-xs-center" style="height: 200;">  
      <v-icon
        color="teal"
        size="80"
        class="ma-3"
      >
        {{ bigIcon }}
      </v-icon>
      <p
        class="category font-weight-bold"
        v-text="title"
      />
      <h3
        class="title display-1 font-weight-light">
        {{ value }} <small>{{ smallValue }}</small>
      </h3>
    </div>
  </material-card>
  </v-layout>
</v-flex>
</template>

<script>
import Card from './Card'

export default {
  inheritAttrs: false,

  props: {
    ...Card.props,
    dropdown:{
      type: Array
    },
    subIcon: {
      type: String,
      default: undefined
    },
    bigIcon: {
      type: String,
      default: undefined
    },
    subIconType:{
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    bigIconColor:{
      type: String,
      default: undefined
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    subText: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>
